var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import gql from "graphql-tag";
import authentication from "@irati/auth";
import { Query } from "@irati/utils/services/apollo";
export var query = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query RewardWallet($tenantId: String!, $currency: String!, $userId: String!) {\n    rewardWallets(tenantId: $tenantId, currency: $currency, userId: $userId) {\n      results {\n        availableBalance\n        currency\n        uuid\n        ownerUuid\n        walletUuid\n      }\n    }\n  }\n"], ["\n  query RewardWallet($tenantId: String!, $currency: String!, $userId: String!) {\n    rewardWallets(tenantId: $tenantId, currency: $currency, userId: $userId) {\n      results {\n        availableBalance\n        currency\n        uuid\n        ownerUuid\n        walletUuid\n      }\n    }\n  }\n"])));
var RewardWalletBalanceQueryComponent = /** @class */ (function (_super) {
    __extends(RewardWalletBalanceQueryComponent, _super);
    function RewardWalletBalanceQueryComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.returnFirstRewardWallet = function (apolloState) {
            if (!apolloState.data) {
                return undefined;
            }
            if (!apolloState.data.rewardWallets) {
                return undefined;
            }
            return apolloState.data.rewardWallets.results[0];
        };
        return _this;
    }
    RewardWalletBalanceQueryComponent.prototype.render = function () {
        var _this = this;
        var variables = {
            currency: authentication.defaultUserCurrency(),
            tenantId: authentication.userTenant().uuid,
            userId: authentication.user().uuid
        };
        return (React.createElement(Query, __assign({ fetchPolicy: "network-only", query: query, variables: variables }, this.props), function (apolloState) {
            return _this.props.children(__assign(__assign({}, apolloState), { data: __assign(__assign({}, apolloState.data), { 
                    // return back the first wallet so we don't need repeated logic
                    rewardWallet: _this.returnFirstRewardWallet(apolloState) }) }));
        }));
    };
    return RewardWalletBalanceQueryComponent;
}(PureComponent));
export default RewardWalletBalanceQueryComponent;
var templateObject_1;
